module.exports = __webpack_public_path__ + "static/media/edit-2.1c8e8a76.svg";